module.exports = __webpack_public_path__ + "0147beaa580bd28541d20b077fb8a09d.png";